import {
    ambiguousDecimalMessage,
    ambiguousDecimalReadings,
    parseDecimalInput,
} from '~/utils/decimalInput';

export interface DoseFactorRefusal {
    readonly id: string;
    readonly values?: Record<string, string>;
}

export type DoseFactorEntry =
    | { readonly factor: number; readonly refusal?: undefined }
    | { readonly factor?: undefined; readonly refusal: DoseFactorRefusal };

const NOT_A_FACTOR: DoseFactorRefusal = { id: 'replanning.dose.scale.invalid' };

const isFactor = (value: number) => value > 0;

// A typed factor read by the app's one rule for typed numbers: a point or a comma is the decimal separator.
export function readDoseFactor(text: string): DoseFactorEntry {
    const entry = text.trim();
    const value = parseDecimalInput(entry);
    if (value === null || !isFactor(value)) {
        return { refusal: NOT_A_FACTOR };
    }
    const readings = ambiguousDecimalReadings(entry, isFactor);
    return readings
        ? { refusal: ambiguousDecimalMessage(entry, readings) }
        : { factor: value };
}
